import { resourceExplorerViewByIdSelector } from "./resourceExplorerViewByIdSelector";
import { RootState } from "../../../store";

export const resourceExplorerByIdLoadingSelector = (
  state: RootState,
  viewId: string,
) => !!resourceExplorerViewByIdSelector(state, viewId)?.isLoading;
